import Vue from "vue";
import { mapGetters } from "vuex";

import comboComponent from "@/components/child/form/combo.vue";
import decimalComSinalCustomComponent from "@/components/child/form/decimalComSinalCustom.vue";
import { Component, Prop, Watch } from "@/decorators";
import KitEmbalagemItemModel from "@/models/kitEmbalagemItemModel";
import PaginationModel from "@/models/paginationModel";
import ProdutoLoteFracionamentoItemEmbalagemModel from "@/models/produtoLoteFracionamentoItemEmbalagemModel";
import ProdutoLoteModel from "@/models/produtoLoteModel";
import ProdutoLoteService from "@/services/produtoLoteService";
import { Getters } from "@/store/store";
import { getProdutoLoteCombo } from "@/utils/common/combo/combotext";

import "../crud.scss";

@Component({
    components: {
        comboComponent,
        decimalComSinalCustomComponent,
    },
    computed: {
        ...mapGetters(["GET_IS_FRACIONAMENTO", "GET_IS_ESTEREIS"] as Getters),
    },
})
export default class FracionamentoKitEmbalagemItemEditComponent extends Vue {
    // State computed props
    GET_IS_FRACIONAMENTO: () => Promise<boolean>;
    GET_IS_ESTEREIS: () => Promise<boolean>;

    private produtoLoteService = new ProdutoLoteService();

    isFracionamento = false;
    isEstereis = false;

    model = new KitEmbalagemItemModel();
    produtoLotes: ProdutoLoteModel[] = [];
    produtoLoteOptions = [];

    @Prop(Number) index: number;
    @Prop(Array) produtoOptions;
    @Prop(Boolean) somenteConsulta: boolean;
    @Prop(Number) estoqueId: number;

    //@ts-ignore
    @Watch("model.produtoId")
    private onChangeProdutoId() {
        if (this.model.produtoId) {
            this.loadProdutoLoteOptions();
        }
    }

    private async loadProdutoLoteOptions() {
        this.produtoLoteOptions = [];
        this.produtoLotes = [];

        try {
            const quantidade = this.somenteConsulta ? 0 : this.model.quantidade;
            const data = await this.produtoLoteService
                .listByProdutoIdAndEstoqueId(this.model.produtoId, this.estoqueId, quantidade, 0, 1, 100000)
                .resolveWithJSON<PaginationModel<ProdutoLoteModel>>();

            this.produtoLotes = data.list;

            this.setProdutoLoteId();
        } catch {}
    }

    //@ts-ignore
    @Watch("produtoLotes")
    private async onChangeProdutoLotes() {
        const exibeCodigo = this.isFracionamento || this.isEstereis;
        this.produtoLoteOptions = this.produtoLotes.map(item => getProdutoLoteCombo(item, exibeCodigo));
    }

    //@ts-ignore
    @Watch("model.produtoLoteId")
    private onChangeProdutoLoteId() {
        this.$emit("onChangeItemEmbalagem", this.model);
    }

    //@ts-ignore
    @Watch("model.quantidade")
    private onChangeQuantidade() {
        if (this.model.produtoId) {
            this.loadProdutoLoteOptions();
        }
    }

    private setProdutoLoteId() {
        const produto = this.produtoOptions.find(p => p["value"] == this.model.produtoId);

        if (produto["ignoraControleEstoque"]) {
            if (this.produtoLotes.length == 0) {
                this.produtoLotes.push(this.geraLoteOutro());
            }
        } else if (this.model.produtoLoteId == null && this.produtoLotes.length > 0) {
            this.model.produtoLoteId = this.produtoLotes.sort((a, b) =>
                a.dataValidade > b.dataValidade ? 1 : 0,
            )[0].id;
        }
    }

    private geraLoteOutro() {
        const lote = new ProdutoLoteModel();
        lote.descricao = "Outro";
        lote.id = 0;
        return lote;
    }

    public async validateAll() {
        return await this.$validator.validateAll();
    }

    public setModel(item: ProdutoLoteFracionamentoItemEmbalagemModel) {
        this.model.updateFrom(item);
    }

    private async mounted() {
        this.isFracionamento = await this.GET_IS_FRACIONAMENTO();
        this.isEstereis = await this.GET_IS_ESTEREIS();
    }
}
